import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '@phase2/outline-core';
import { customElement, property } from 'lit/decorators.js';
import componentStyles from './pc-accordion-trigger.css.lit';
import '../../pc-icon/pc-icon';

/**
 * The Accordion Trigger component
 * @element pc-accordion-trigger
 */
@customElement('pc-accordion-trigger')
export class PCAccordionTrigger extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true })
  variant: 'primary' | 'secondary' = 'primary';

  @property({ type: Boolean, reflect: true })
  active = false;

  updated(): void {
    this.setAttribute('aria-expanded', `${this.active}`);
  }

  render(): TemplateResult {
    return html`
      <button class="accordion-trigger">
        <div class="accordion-trigger--label">
          <slot></slot>
          <slot name="secondary-label"></slot>
        </div>

        <span class="accordion-trigger--icon">
          <pc-icon name="${this.active ? 'close' : 'plus'}"></pc-icon>
        </span>
      </button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'pc-accordion-trigger': PCAccordionTrigger;
  }
}
